module.exports = __webpack_public_path__ + "img/folder-plus.a8bb4655.svg";